"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InProgress = function InProgress() {
  return _react2.default.createElement(
    "g",
    { id: "inprogress" },
    _react2.default.createElement("path", {
      d: "M62.5,188 C79.0776571,187.994693 94.9778605,194.577791 106.700035,206.299965 C118.422209,218.022139 125.005307,233.922343 125,250.5 C125,285.017797 97.0177969,313 62.5,313 C27.9822031,313 -4.22721094e-15,285.017797 0,250.5 C4.22721094e-15,215.982203 27.9822031,188 62.5,188 Z M250,188 C266.577657,187.994693 282.477861,194.577791 294.200035,206.299965 C305.922209,218.022139 312.505307,233.922343 312.5,250.5 C312.5,285.017797 284.517797,313 250,313 C215.482203,313 187.5,285.017797 187.5,250.5 C187.5,215.982203 215.482203,188 250,188 Z M437.5,188 C454.077657,187.994693 469.977861,194.577791 481.700035,206.299965 C493.422209,218.022139 500.005307,233.922343 500,250.5 C500,285.017797 472.017797,313 437.5,313 C402.982203,313 375,285.017797 375,250.5 C375,215.982203 402.982203,188 437.5,188 Z",
      id: "Combined-Shape"
    })
  );
};

exports.default = InProgress;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/InProgress.js
// module id = 2961
// module chunks = 4